// Central content for Alphatech Labz marketing site
import {
  Layers, Trophy, Bitcoin, Rocket, Puzzle, Plug,
  CreditCard, Building2, LifeBuoy, ShieldCheck, Clock, Zap,
  Settings2, Sparkles, MessageSquareText, Wallet2,
} from "lucide-react";

export const COMPANY = {
  name: "Alphatech Labz FZ LLC",
  short: "Alphatech Labz",
  tagline: "Powering the Next Generation of iGaming",
  email: "sales@alphatechlabz.com",
  phone: "+44 7577 308890",
  address: "Business Bay, Dubai, United Arab Emirates",
  domain: "alphatechlabz.com",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Solutions", to: "/solutions" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = [
  { icon: Layers,      title: "White Label Casino",       desc: "Launch-ready casino platform with 10,000+ games, custom branding and full backend." },
  { icon: Trophy,      title: "White Label Sportsbook",   desc: "Pre-built sportsbook with live odds, 30+ sports, and licensed sports feed API." },
  { icon: Sparkles,    title: "Online Casino Software",   desc: "Modular casino software stack — CMS, wallet, bonus engine and game aggregator." },
  { icon: Bitcoin,     title: "Crypto Casino Solutions",  desc: "Multi-currency crypto casino with on-chain payments and provably fair games." },
  { icon: Rocket,      title: "Turnkey Casino Platform",  desc: "Ready-to-deploy turnkey solution — go live under your brand within days, not months." },
  { icon: Puzzle,      title: "Game Aggregation",         desc: "Single API access to 100+ providers: Evolution, Pragmatic, Netent, Ezugi and more." },
  { icon: Plug,        title: "API Integration",          desc: "Battle-tested REST APIs, webhooks and SDKs for casino, sportsbook and payments." },
  { icon: CreditCard,  title: "Payment Gateway",          desc: "250+ payment integrations — cards, wallets, UPI, crypto, local processors." },
  { icon: Building2,   title: "Enterprise Gaming Tech",   desc: "Custom-engineered platforms for enterprise operators with SLA-backed uptime." },
];

export const SOLUTIONS = [
  {
    title: "White Label Casino",
    subtitle: "Own-brand casino, live in 72 hours",
    features: ["100+ pre-built designs", "10,000+ games", "Authorized APIs & No Scrap", "Bonus & referral engine"],
    variant: "roulette",
  },
  {
    title: "White Label Sportsbook",
    subtitle: "All-in-one sportsbook platform",
    features: ["Live in-play betting", "Real-time odds feed", "Risk management tools", "30+ sports covered"],
    variant: "stadium",
  },
  {
    title: "Crypto Casino Software",
    subtitle: "Multi-crypto casino with on-chain wallets",
    features: ["BTC, ETH, USDT, TRX support", "Provably fair games", "Instant crypto payouts", "Cold + hot wallet infra"],
    variant: "blockchain",
  },
  {
    title: "Turnkey iGaming Platform",
    subtitle: "Complete branded platform, hands-off",
    features: ["Curaçao license support", "Payment integrations", "CMS + admin panel", "24/7 managed hosting"],
    variant: "dashboard",
  },
];

export const GAMES = [
  { title: "Live Dealer", tag: "Live Casino", variant: "livedealer" },
  { title: "Roulette",    tag: "Table Games", variant: "roulette" },
  { title: "Slots",       tag: "Slots",       variant: "slots" },
  { title: "Blackjack",   tag: "Table Games", variant: "blackjack" },
  { title: "Sportsbook",  tag: "Sports",      variant: "stadium" },
  { title: "Crypto Games",tag: "Crypto",      variant: "crypto" },
  { title: "Poker",       tag: "Card Games",  variant: "poker" },
  { title: "Fast Games",  tag: "Instant Win", variant: "fastgames" },
];

export const WHY_CHOOSE = [
  { icon: Wallet2,        title: "Cost Effective",       desc: "Scalable pricing built for early-stage operators to enterprises." },
  { icon: LifeBuoy,       title: "24/7 Support",         desc: "Dedicated account managers and round-the-clock engineering." },
  { icon: Zap,            title: "Quick Launch",         desc: "From onboarding to live in as little as 72 hours." },
  { icon: Plug,           title: "API & Integrations",   desc: "Authorized APIs and battle-tested webhook infrastructure." },
  { icon: Settings2,      title: "Customizable",         desc: "White-label everything — UI, wallet flow, bonus logic, and CMS." },
  { icon: MessageSquareText, title: "Free Consultation", desc: "Free jurisdiction and licensing consult for every new client." },
  { icon: ShieldCheck,    title: "Anti-Fraud",           desc: "AML, KYC and fraud rules engine baked into the platform." },
  { icon: Sparkles,       title: "Diverse Portfolio",    desc: "10,000+ games across slots, live, sports, and crypto verticals." },
];

export const STATS = [
  { value: "10+", label: "Years in iGaming" },
  { value: "120+", label: "Game Provider Partners" },
  { value: "10K+", label: "Games Available" },
  { value: "300+", label: "Projects Launched" },
];

export const PARTNERS = [
  "Evolution", "Ezugi", "Pragmatic Play", "NetEnt", "Spribe", "Qtech",
  "Hacksaw", "Red Tiger", "Quickspin", "Kingmaker", "JILI", "XPG",
  "Vivo Gaming", "PowerGames", "OnlyPlay", "Supernowa",
];

export const LICENSES = [
  "Curaçao Gambling License",
  "Malta Gaming Authority",
  "B2B Supplier · Belarus",
  "B2B License · Greece",
  "B2B Supplier · Latvia",
  "Belgian Gambling License",
  "Anjouan License",
  "Kahnawake License",
];

export const TESTIMONIALS = [
  {
    quote:
      "Alphatech's turnkey stack cut our launch time from months to a single sprint. Their engineering team just gets iGaming.",
    name: "M. Al-Rashid",
    role: "COO, Gulf Bet Group",
  },
  {
    quote:
      "The aggregator API is rock-solid. 8,000+ games plugged in cleanly and the settlement flow is flawless.",
    name: "Elena Novak",
    role: "Head of Product, Rivera Casino",
  },
  {
    quote:
      "We picked Alphatech over three other vendors after a 2-week POC. Best decision for our crypto casino roadmap.",
    name: "David Chen",
    role: "Founder, ChainBet",
  },
  {
    quote:
      "Their bonus engine and CRM hooks helped us lift 30-day retention by 18%. Real, measurable results.",
    name: "Priya Menon",
    role: "Growth Director, PlayNova",
  },
];

export const COUNTRIES = [
  "United Kingdom", "United Arab Emirates", "United States", "India", "Canada",
  "Germany", "France", "Spain", "Italy", "Netherlands", "Malta", "Cyprus",
  "Curaçao", "South Africa", "Nigeria", "Kenya", "Brazil", "Mexico",
  "Argentina", "Australia", "Philippines", "Singapore", "Japan", "Turkey",
  "Saudi Arabia", "Egypt", "Portugal", "Sweden", "Denmark", "Norway",
];

export const SERVICE_INTERESTS = [
  "White Label Casino",
  "White Label Sportsbook",
  "Crypto Casino",
  "Turnkey Platform",
  "Game Aggregation",
  "API Integration",
  "Payment Gateway",
  "Managed Services",
  "Other",
];
